export enum Status {
  OK = "OK",
  NOK = "NOK",
}
